export default __webpack_public_path__ + "static/media/profile-photo.7c3dc2ef.jpg";